import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code`
  const result = await bService.get(url)

  return result
}

const detail = async (hotelId, rateCodeId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code/${rateCodeId}/rate-detail`
  const result = await bService.get(url)

  return result
}

const create = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code`
  const result = await bService.post(url, data)

  return result
}

const update = async (hotelId, rateCodeId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code/${rateCodeId}`
  const result = await bService.put(url, data)

  return result
}

const updateIsDefault = async (hotelId, rateCodeId, isDefault) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code/${rateCodeId}/is-default`
  const data = {
    isDefault: isDefault
  }
  const result = await bService.put(url, data)

  return result
}

const remove = async (hotelId, rateCodeId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/rate-code/${rateCodeId}`
  const result = await bService.remove(url)

  return result
}

export default {
  list,
  detail,
  create,
  update,
  updateIsDefault,
  remove
}
